/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SearchRouteImport } from './routes/search'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedSavedRouteImport } from './routes/_authed.saved'
import { Route as AuthedInboxRouteImport } from './routes/_authed.inbox'
import { Route as AuthedSavedIndexRouteImport } from './routes/_authed.saved.index'
import { Route as AuthedSavedIdRouteImport } from './routes/_authed.saved.$id'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusRoute = StatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSavedRoute = AuthedSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInboxRoute = AuthedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSavedIndexRoute = AuthedSavedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedSavedRoute,
} as any)
const AuthedSavedIdRoute = AuthedSavedIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedSavedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/privacy': typeof PrivacyRoute
  '/search': typeof SearchRoute
  '/sign-in': typeof SignInRoute
  '/status': typeof StatusRoute
  '/terms': typeof TermsRoute
  '/inbox': typeof AuthedInboxRoute
  '/saved': typeof AuthedSavedRouteWithChildren
  '/settings': typeof AuthedSettingsRoute
  '/saved/$id': typeof AuthedSavedIdRoute
  '/saved/': typeof AuthedSavedIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/privacy': typeof PrivacyRoute
  '/search': typeof SearchRoute
  '/sign-in': typeof SignInRoute
  '/status': typeof StatusRoute
  '/terms': typeof TermsRoute
  '/inbox': typeof AuthedInboxRoute
  '/settings': typeof AuthedSettingsRoute
  '/saved/$id': typeof AuthedSavedIdRoute
  '/saved': typeof AuthedSavedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/about': typeof AboutRoute
  '/privacy': typeof PrivacyRoute
  '/search': typeof SearchRoute
  '/sign-in': typeof SignInRoute
  '/status': typeof StatusRoute
  '/terms': typeof TermsRoute
  '/_authed/inbox': typeof AuthedInboxRoute
  '/_authed/saved': typeof AuthedSavedRouteWithChildren
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/saved/$id': typeof AuthedSavedIdRoute
  '/_authed/saved/': typeof AuthedSavedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/privacy'
    | '/search'
    | '/sign-in'
    | '/status'
    | '/terms'
    | '/inbox'
    | '/saved'
    | '/settings'
    | '/saved/$id'
    | '/saved/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/privacy'
    | '/search'
    | '/sign-in'
    | '/status'
    | '/terms'
    | '/inbox'
    | '/settings'
    | '/saved/$id'
    | '/saved'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/about'
    | '/privacy'
    | '/search'
    | '/sign-in'
    | '/status'
    | '/terms'
    | '/_authed/inbox'
    | '/_authed/saved'
    | '/_authed/settings'
    | '/_authed/saved/$id'
    | '/_authed/saved/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  AboutRoute: typeof AboutRoute
  PrivacyRoute: typeof PrivacyRoute
  SearchRoute: typeof SearchRoute
  SignInRoute: typeof SignInRoute
  StatusRoute: typeof StatusRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status': {
      id: '/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof StatusRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/saved': {
      id: '/_authed/saved'
      path: '/saved'
      fullPath: '/saved'
      preLoaderRoute: typeof AuthedSavedRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/inbox': {
      id: '/_authed/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthedInboxRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/saved/': {
      id: '/_authed/saved/'
      path: '/'
      fullPath: '/saved/'
      preLoaderRoute: typeof AuthedSavedIndexRouteImport
      parentRoute: typeof AuthedSavedRoute
    }
    '/_authed/saved/$id': {
      id: '/_authed/saved/$id'
      path: '/$id'
      fullPath: '/saved/$id'
      preLoaderRoute: typeof AuthedSavedIdRouteImport
      parentRoute: typeof AuthedSavedRoute
    }
  }
}

interface AuthedSavedRouteChildren {
  AuthedSavedIdRoute: typeof AuthedSavedIdRoute
  AuthedSavedIndexRoute: typeof AuthedSavedIndexRoute
}

const AuthedSavedRouteChildren: AuthedSavedRouteChildren = {
  AuthedSavedIdRoute: AuthedSavedIdRoute,
  AuthedSavedIndexRoute: AuthedSavedIndexRoute,
}

const AuthedSavedRouteWithChildren = AuthedSavedRoute._addFileChildren(
  AuthedSavedRouteChildren,
)

interface AuthedRouteChildren {
  AuthedInboxRoute: typeof AuthedInboxRoute
  AuthedSavedRoute: typeof AuthedSavedRouteWithChildren
  AuthedSettingsRoute: typeof AuthedSettingsRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedInboxRoute: AuthedInboxRoute,
  AuthedSavedRoute: AuthedSavedRouteWithChildren,
  AuthedSettingsRoute: AuthedSettingsRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  AboutRoute: AboutRoute,
  PrivacyRoute: PrivacyRoute,
  SearchRoute: SearchRoute,
  SignInRoute: SignInRoute,
  StatusRoute: StatusRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
